import styled from 'styled-components';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';

export const TreeSelectWrapper = styled.div`
  width: 50%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  & span {
    font-weight: bold;
    font-size: 1rem;
    margin-right: 15px;
    white-space: nowrap;
  }

  @media screen and (max-width: 900px) {
    width: 100%;
  }
`;

export const Table = styled(StaticTablePagination)`
  .MuiFormControlLabel-root {
    margin: 0 !important;
  }

  .rt-thead.-header {
    top: -15px !important;
  }

  .rt-thead.-filters {
    top: 25px !important;
  }

  .MuiInputBase-root {
    max-height: 46px;
  }

  .MuiFormControl-root {
    overflow: hidden;
    padding-top: 1px;
  }
`;

export const TableWrapper = styled.div`
  .MuiFormControlLabel-root {
    margin: 0 !important;
  }
  .rt-td:first-child {
    //padding: 0 !important;
  }

  .rt-thead.-header {
    top: -15px !important;
  }

  .rt-thead.-filters {
    top: 25px !important;
  }
`;
